import { FlexCol, FlexGridCol, FlexRow } from '@makemydeal/dr-dash-components';

import { Typography } from '@interstate/components/Typography';

import { LIENHOLDER_FORM_HEADER_TITLE, LienholderFormHeaderControlIds } from './constants';

const LienholderFormHeader = () => (
    <FlexGridCol data-testid={LienholderFormHeaderControlIds.Header}>
        <FlexCol>
            <FlexRow justifyContent="space-between" alignItems="center">
                {
                    <>
                        <Typography variant={'h4'}>{LIENHOLDER_FORM_HEADER_TITLE}</Typography>
                    </>
                }
            </FlexRow>
        </FlexCol>
    </FlexGridCol>
);

export default LienholderFormHeader;
